export default function hasValue(value: unknown): boolean {
  return value !== null && value !== undefined;
}
